export default __webpack_public_path__ + "static/media/solidworks.f2be369a.png";